import React from 'react';
import dayjs from 'dayjs';
import BasicSelect from './BasicSelect.jsx';
import Label from './Label.jsx';
import { ThemeProvider } from '@mui/material/styles';
import { backYouTheme } from '../../../../theme';
import { LocalizationProvider } from '@mui/x-date-pickers-v5/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers-v5/AdapterDayjs';
import YearPicker from './YearPicker.jsx';

export default function CompareYear(props) {
  const {
    slug,
    labelYear1,
    labelYear2,
    labelType = null,
    selectedYear1 = null,
    selectedYear2 = null,
    typeItems = [],
    selectedTypeItems = null,
    maxDate1,
    maxDate2,
    autoTrad,
    parentFunction,
    disableCompareType = false
  } = props;

  return (
    <ThemeProvider theme={backYouTheme}>
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={ENV.lang.split('_').shift()}>
        <div className="d-flex flex-wrap justify-content-md-center">
          <div className="d-flex flex-md-nowrap align-items-center mt-3">
            <div className="pr-3">
              <Label htmlForValue={"compare-year-1"} label={labelYear1.trad()} style={{ marginBottom: 0 }} />
            </div>
            <div className="mr-md-4" style={{ width: '11rem' }}>
              <div className="ml-md-2">
                <YearPicker
                  id="compare-year-1"
                  slug={slug + '_year_1'}
                  value={dayjs(String(selectedYear1))}
                  maxDate={maxDate1 ? dayjs(String(maxDate1)) : null}
                  parentFunction={(year, slug) => {
                    if (dayjs(String(year))?.$y && (maxDate1 ? (dayjs(String(year)).isBefore(dayjs(String(maxDate1)).add(1, 'year'))) : true)) {
                      parentFunction(year, slug);
                    }
                  }}
                />
              </div>
            </div>
          </div>

          { !disableCompareType && (
            <div className="d-flex flex-md-nowrap align-items-center mt-3">
              <div className="pr-3">
                <Label htmlForValue={"compare-type"} label={labelType.trad()} style={{ marginBottom: 0 }} />
              </div>
              <div className="mr-md-4" style={{ width: '20rem' }}>
                <div className="ml-md-2">
                  <BasicSelect
                    id="compare-type"
                    slug={slug + '_type'}
                    items={typeItems}
                    selectedItems={selectedTypeItems}
                    autoTrad={autoTrad}
                    parentFunction={parentFunction}
                    displayEmptyValue={false}
                  />
                </div>
              </div>
            </div>
          )}

          <div className="d-flex flex-md-nowrap align-items-center mt-3">
            <div className="pr-3">
              <Label htmlForValue={"compare-year-2"} label={labelYear2.trad()} style={{ marginBottom: 0 }} />
            </div>
            <div style={{ width: '11rem' }}>
              <div className="ml-md-2">
                <YearPicker
                  id="compare-year-2"
                  slug={slug + '_year_2'}
                  value={dayjs(String(selectedYear2))}
                  maxDate={maxDate2 ? dayjs(String(maxDate2)) : null}
                  parentFunction={(year, slug) => {
                    if (dayjs(String(year))?.$y && (maxDate2 ? (dayjs(String(year)).isBefore(dayjs(String(maxDate2)).add(1, 'year'))) : true)) {
                      parentFunction(year, slug);
                    }
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </LocalizationProvider>
    </ThemeProvider>
  );
}